module.exports = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};


//# sourceMappingURL=ja-JP.main.js.map
